/* eslint-disable @typescript-eslint/no-explicit-any */
import * as yup from 'yup'

const schema = yup
  .object({
    name: yup.string().required('Nome é obrigatório'),
    cpf: yup.string().required('O CPF é obrigatório'),
    birthDate: yup
      .string()
      .required('Este campo é obrigatório')
      .test('qtd-digits', 'Data incompleta', (value: any) => {
        if (!value || value === '') {
          return true
        }

        return value.length > 9
      })
      .test('valid-date', 'Formato da data é inválido', value => {
        const [day, month, year] = value.split('/')
        const dateInInput = new Date(`${month}-${day}-${year}`).valueOf()

        if (+year < 1970 || +year >= new Date().getFullYear()) return false

        return !!dateInInput
      }),
    email: yup
      .string()
      .email('E-mail inválido')
      .required('E-mail é obrigatório'),
    phone: yup
      .string()
      .test('qtd-digits', 'Número de celular incompleto', (value: any) => {
        if (!value || value === '') {
          return true
        }

        return value.length > 14
      })
      .required('O celular é obrigatório'),
    linkedin: yup.string().url('URL inválida').nullable()
  })
  .required()

type FormData = yup.InferType<typeof schema>

const defaultValues = {
  cpf: '',
  name: '',
  email: '',
  birthDate: '',
  phone: '',
  linkedin: ''
}

export const parseJSONCurriculum = (json: any) => {
  const experiences = (json?.experiences || []) as any[]

  return {
    ...json,
    languages: [],
    courses: [],
    experiences: experiences.map(
      ({ company, description, occupation, duration }) => {
        const startDate = duration?.start_date || ''
        const endDate = duration?.end_date || ''
        const current = endDate === 'Presente'

        return {
          current,
          description,
          company: company || '',
          occupation: occupation || '',
          startDate: startDate.length >= 10 ? startDate : '',
          endDate: !current && endDate.length >= 10 ? endDate : ''
        }
      }
    )
  }
}

export { schema, type FormData, defaultValues }
